import React from 'react'
import { Badge } from './styles'

export interface IBiRadsBadgeProps {
  category: number
  size?: 'sm' | 'md' | 'lg'
}

export const BiRadsBadge = ({ category, size = 'md' }: IBiRadsBadgeProps): JSX.Element => {
  return <Badge category={category} size={size}>{`Bi-RADS ${category}`}</Badge>
}
